import moment from 'moment'
import ApiClient from 'api-client/ApiClient'
import store from 'app/store'
import ActionsSet from 'core/actions/ActionsSet'
import CreateAction from 'core/actions/CreateAction'
import CustomAction from 'core/actions/CustomAction'
import DeleteAction from 'core/actions/DeleteAction'
import ListAction from 'core/actions/ListAction'
import UpdateAction from 'core/actions/UpdateAction'
import { cacheActions } from 'core/caching/cacheReducers'
import { isAdminRole } from 'core/utils/rbac'
import DataKeys, { entityNamesByKey } from 'k8s/DataKeys'

const { dispatch } = store
const { nova } = ApiClient.getInstance()

const getCurrentNovaFormattedTimestamp = () => {
  return moment().utc().format()
}

let lastRefreshTime = null

export const migrationActions = ActionsSet.make<DataKeys.VmMigrations>({
  uniqueIdentifier: 'id',
  entityName: entityNamesByKey.VmMigrations,
  cacheKey: DataKeys.VmMigrations,
})

export const listMigrations = migrationActions.add(
  new ListAction<DataKeys.VmMigrations>(async () => {
    // FR-001: os-migrations is admin-only in Nova; skip the call for other roles
    if (!isAdminRole()) {
      return []
    }
    const newTimestamp = getCurrentNovaFormattedTimestamp()
    lastRefreshTime = newTimestamp
    return nova.getMigrations()
  }),
)

export const getMigrationsSince = migrationActions.add(
  new CustomAction<DataKeys.VmMigrations>(
    'getMigrationsSince',
    async () => {
      // FR-001: also re-checked on each poll so a role switch stops the polling
      if (!lastRefreshTime || !isAdminRole()) {
        return []
      }
      const migrations = await nova.getMigrationsSince(lastRefreshTime)
      const newTimestamp = getCurrentNovaFormattedTimestamp()
      lastRefreshTime = newTimestamp
      return migrations
    },
    (result: any[], {}) => {
      dispatch(
        cacheActions.upsertAll({
          uniqueIdentifier: 'id',
          cacheKey: DataKeys.VmMigrations,
          items: result,
        }),
      )
    },
  ),
)
